module.exports = __webpack_public_path__ + "static/media/assicurazioni-card.7575ad63.jpg";